
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-of-sale",
      function () {
        return require("private-next-pages/terms-of-sale/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms-of-sale"])
      });
    }
  